import UserAvatar20 from '@carbon/icons-react/es/user--avatar/20';
import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { Button } from 'components/atoms/button';
import { useTranslation } from 'hooks/use-translation';
import { Trigger } from '../squad-picker/trigger';
import { Option } from '../squad-picker/types';

const TriggerButton = styled(Button)<{ icon?: ReactNode }>`
  .ant-tag {
    cursor: inherit;
  }
  color: ${(props) => props.icon && 'var(--link-color)'};
  padding-left: ${(props) => !props.icon && 'var(--spacing-03)'};
  padding-right: ${(props) => !props.icon && 'var(--spacing-03)'};
`;

export const DefaultTrigger = ({ value, isMini, onClick }) => {
  const choose = useTranslation('choose');

  return (
    <TriggerButton
      data-cy="choose.assignee"
      onClick={onClick}
      type="text"
      size="small"
      icon={(value ?? []).length > 0 ? null : <UserAvatar20 />}
    >
      {value && value.length > 0 ? (
        <Trigger size="small" isMini={isMini} value={value as Option[]} />
      ) : (
        !isMini && choose
      )}
    </TriggerButton>
  );
};
